import imageOne from "../../../assets/images/Image (1).png";
import imageTwo from "../../../assets/images/Image (2).png";

export const INITIAL_FILTERS = {
  status: undefined,
  sort: undefined,
};

export const SORT_OPTIONS = [
  { value: "newest", label: "Newest" },
  { value: "oldest", label: "Oldest" },
];

export const STATUS_OPTIONS = [
  { value: "assigned", label: "Assigned" },
  { value: "unassigned", label: "Unassigned" },
];

export const TABLE_PAGINATION = {
  defaultPageSize: 20,
  showSizeChanger: true,
  pageSizeOptions: ["20", "50", "100"],
  showTotal: (total) => `Total ${total} items`,
};

export const ASSIGNMENTS = [
  {
    thumbnail: imageTwo,
    duration: "15:43",
    organizationLogo: imageOne,
    organizationName: "Roku, Inc.",
    campaign: "Yearly Campaign",
    survey: "July Survey",
    interpreterName: "Mary Freund",
    interpreterEmail: "david20@gmail.com",
    completedDate: "Aug 22, 2024",
    status: "Completed",
    interpreterImage: imageOne,
  },
];
